import { Button, CircularProgress, useTheme } from "@mui/material";
import { FC, useContext, useEffect, useRef, useState } from "react";
// import LogComonent from "../layouts/LogComonent";
import { useParams } from "react-router-dom";
import { useMutation } from "react-query";
import {
  getPrescriptionClaimForm,
  getPrescriptionPrint,
  submitErx,
} from "../../services";
import { EmrContext } from "../..";
import usePopup from "../../../hooks/usePopup";
import { PrescriptionContext } from ".";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { ErrorObjectType } from "../../../Insurance/ClaimListing/types";
import useAuthentication from "@hooks/useAuthentication";

const ButtonsContainer: FC = () => {
  const theme = useTheme();
  const {user} = useAuthentication()
  const { encounterId } = useParams();
  const { patientData } = useContext(EmrContext);
  const { list } = useContext(PrescriptionContext);
  const { showSnackbar, CustomModal } = usePopup();
  const [open, setOpen] = useState(false);
  const [errorList, setErrorList] = useState<ErrorObjectType[]>();
  const downloadLinkRef = useRef<HTMLAnchorElement | null>(null);
  const { mutate: submitErxOClick, isLoading: submitErxLoading } = useMutation(
    submitErx,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          const response = result.response;
          if (response?.Success) {
            showSnackbar({
              message: result.responseMessage,
              open: true,
              variant: "success",
              duration: 2000,
            });
            
          } else {
            setOpen(true);
            setErrorList(response?.Error);
          }
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
    }
  );

  const { mutate: getPrescription, isLoading: prescriptionLoading } =
    useMutation(getPrescriptionPrint, {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          const byteCharacters = atob(result.response);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);
          window.open(url, "_blank");
        } else {
          showSnackbar({
            message: result.responseMessage,
            variant: "warning",
            open: true,
            duration: 2000,
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Failed to open the pdf",
          variant: "warning",
          open: true,
          duration: 2000,
        });
      },
    });

  const { mutate: printClaimForm, isLoading: claimFormLoading } = useMutation(
    getPrescriptionClaimForm,
    {
      onSuccess: (result) => {
        // const blob = new Blob([result.response], { type: "application/pdf" });
        if (result.responseIndicator == "success" && result.response) {
          const binaryData = atob(result.response);
          const byteNumbers = new Uint8Array(binaryData.length);
          for (let i = 0; i < binaryData.length; i++) {
            byteNumbers[i] = binaryData.charCodeAt(i);
          }
          const blob = new Blob([byteNumbers], { type: "application/pdf" });
          const blobURL = URL.createObjectURL(blob);
          window.open(blobURL, "_blank");
        }
      },
      onError: () => {
        showSnackbar({
          message: "Failed to open the pdf",
          variant: "warning",
          open: true,
          duration: 2000,
        });
      },
    }
  );

  const handleSubmitErx = () => {
    submitErxOClick({
      encounterId: encounterId as string,
      paymentType: patientData?.pmaster?.paymentMode,
    });
  };

  const handlePrint = () => {
    getPrescription({
      encounterId: encounterId as string,
      paymentMode: patientData?.pmaster?.paymentMode,
      region:user?.region
    });
  };

  const handlePrintClaimForm = () => {
    printClaimForm(parseInt(encounterId as string));
  };

  useEffect(() => {
    console.log(list.length > 0);
  }, []);

  return (
    <div className="w-full flex flex-row items-center justify-end gap-2 p-2 ">
      <CustomModal title="Submission response" open={open} setOpen={setOpen}>
        <div className="p-3 w-[50vw] h-[50dvh] max-h-[50dvh] overflow-y-auto">
          <TreeView
            aria-label="file system navigator"
            // defaultCollapseIcon={<ExpandMoreIcon />}
            // defaultExpandIcon={<ChevronRightIcon />}
            sx={{ overflowX: "hidden" }}
          >
            {errorList?.map((e, i) => (
              <TreeItem
                key={`${i}TreeItem`}
                sx={{ color: theme.palette.error.main, marginY: 1 }}
                nodeId={`${i}item`}
                label={
                  <div>
                    <FiberManualRecordIcon sx={{ fontSize: "8px" }} />{" "}
                    {e.ErrorText}
                  </div>
                }
              />
            ))}
          </TreeView>
        </div>
      </CustomModal>
      <a
        className="hidden"
        ref={downloadLinkRef}
        style={{ display: "none" }}
      ></a>
      {user?.region == "UAE_REGION" && <Button
        onClick={handleSubmitErx}
        disabled={submitErxLoading || !(list.length > 0)}
        endIcon={submitErxLoading && <CircularProgress size={18} />}
      >
        submit erx
      </Button>}
      <Button
        onClick={handlePrint}
        disabled={prescriptionLoading || !(list.length > 0)}
        endIcon={prescriptionLoading && <CircularProgress size={18} />}
      >
        print
      </Button>
      {Boolean(patientData?.pmaster?.paymentMode && user?.region == "UAE_REGION") && (
        <Button
          onClick={handlePrintClaimForm}
          disabled={claimFormLoading}
          endIcon={claimFormLoading && <CircularProgress size={18} />}
        >
          claim form
        </Button>
      )}
      {/* <LogComonent field="prescription" title="Prescription" /> */}
    </div>
  );
};

export default ButtonsContainer;
